import { customAlphabet } from 'nanoid';

export const customNanoId = customAlphabet('1234567890ABCDEFGH', 10);
// check prod or dev
